<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';

export default {
	extends: Base,
  	data(){
	    return {
			Name:"BoTrxBudgeting",
			BudgetCashType: {},
			BudgetType: {},
			BudgetCategory: {},
			total_debit_dm: '',
			total_credit_dm: '',
			total_saldo_dm: '',
			total_debit_filter_dm: '',
			total_credit_filter_dm: '',
			total_saldo_filter_dm: '',

			total_debit_pc: '',
			total_credit_pc: '',
			total_saldo_pc: '',
			total_debit_filter_pc: '',
			total_credit_filter_pc: '',
			total_saldo_filter_pc: '',

			total_debit_sc: '',
			total_credit_sc: '',
			total_saldo_sc: '',
			total_debit_filter_sc: '',
			total_credit_filter_sc: '',
			total_saldo_filter_sc: '',

			open_edit: '',
			open_add_cat: '',

			total_debit: '',
			total_credit: '',
			total_saldo: '',
			total_debit_filter: '',
			total_credit_filter: '',
			total_saldo_filter: '',
			detail: '',
			row2: {},
			row: {tb_trx_date:''},
	    }
  	},
  	mounted(){
    	this.$set(this.$root, 'page', this)
		this.refreshData()
		$(document).on('hidden.bs.modal', '#addNewCategory', ()=>{
		  	if(this.row.tb_category == '-1') this.$set(this.row, 'tb_category', '')
		  	this.row2 = {}
		});
	},
	methods:{
		onRefershPage(resp){
			setTimeout(()=>{
				if(resp.date_now) this.$set(this.row, 'tb_trx_date', resp.date_now)
			}, 300)
		},
		openDetail: function(v){
			$("#detailBudget").modal();
			BOGen.apirest("/"+this.Name,{type:'detail', id:v.id},(e,resp)=>{
				if(e) return console.log(e);
				this.detail = resp;
			},'POST')
        },
        addNewCategory: function(e){
            if(e.val == -1){
            	$("#addNewCategory").modal();
            }
        },
        submitCategory(e, callback){
        	if(e&&e.btnLoading()) return;
        	BOGen.apirest("/"+this.Name,Object.assign({type:'addCategory'}, this.row2),(err,resp)=>{
        		if(e) e.btnUnloading()
		        if(resp.error){
		          if(this.errorFormCallback) return this.errorFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "danger")
		        }
		        if(resp.success){
		          if(this.successFormCallback) return this.successFormCallback(resp);
		          if(callback) return callback(resp);
		          return Gen.infoModal(resp.message, "success", 1000).then(()=>{
		          	$("#addNewCategory").modal("hide");
		          	this.BudgetCategory.push(resp.newCategory)
		          	this.$set(this.row, 'tb_category', resp.lastCategory)
		          })
		        }
			},'POST')
        }
	},
  watch:{
    '$route.query'(v){ this.refreshData() },
	'filter.cash_type'(v){
		if(!v) return
		this.search()
	},
	'filter.budget_type'(v){ 
		if(!v) return
		this.search()
	},
	'filter.budget_category'(v){
		if(!v) return
		this.search()
	},
  }
}
</script>

<template>
	<div class="container-fluid">
		<PageTitle></PageTitle>
		
		<!-- ======================================================================== 
			LIST DATA
		============================================================================= -->
		<div class="panel panel-flat" v-if="!$route.params.id">
			<div class="panel-body panel-filter">
				<VForm @resp="search" id="form_budget">
					<div class="row">
						<div class="col-sm-3">
							<h3 class="box-title">{{ObjectName}} List 
								<!-- <span v-if="data.total">({{(data.total||0).format()}})</span> -->
							</h3>
						</div>
						<div class="col-sm-9"></div>
					</div>
					<div class="row">
						<div class="col-sm-4">
							<div class="input-group">
								<div class="input-group-addon"><span class="ti-calendar"></span></div>
		                      	<DateRangePicker v-model="filter.rangeDate" placeholder="Range Date"></DateRangePicker>
		                    </div>
						</div>
						<div class="col-sm-2">
							<select2 :options="BudgetCashType" :object="['mbct_id','mbct_sortname']" v-model="filter.cash_type" class="form-control">
								<option value="">Cash Type</option>
							</select2>
						</div>
						<div class="col-sm-2">
							<select2 :options="BudgetType" :object="['bgt_id','bgt_type']" v-model="filter.budget_type" class="form-control">
								<option value="">Type</option>
							</select2>
						</div>
						<div class="col-sm-3">
							<select2 :options="BudgetCategory" :object="['mbc_id','mbc_category']" v-model="filter.budget_category" class="form-control">
									<option value="">Category</option>
								</select2>
						</div>
						<div class="col-sm-1">
							<router-link :to="{name:Name}" class="btn btn-warning">Reset</router-link>
						</div>
					</div>
				</VForm>
			</div>
			<div class="panel-body">
				<div class="row" id="info_panel">
			        <div class="col-md-3">
			            <div class="panel_box table-responsive">
			                <h3 class="font_red">Duty Meal</h3>
			                <table class="table table_info table-responsive">
			                     <tbody>
			                     	<tr>
			                     		<td colspan="2">Debit</td>
			                     	</tr>
			                        <tr>
			                            <td>{{ total_debit_dm }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_debit_filter_dm }}</strong></td>
			                        </tr>
			                        <tr>
			                     		<td colspan="2">Credit</td>
			                     	</tr>
			                        <tr>
			                            <td>{{ total_credit_dm }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_credit_filter_dm }}</strong></td>
			                        </tr>
			                        <tr class="font_red">
			                     		 <td colspan="2">Saldo</td>
			                     	</tr>
			                        <tr class="font_red">
			                            <td>{{ total_saldo_dm }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_saldo_filter_dm }}</strong></td>
			                        </tr>
			                    </tbody>
			                </table>
			            </div>
			        </div>
			        <div class="col-md-3">
			            <div class="panel_box">
			                <h3 class="font_green">Petty Cash</h3>
			                <div class="table-responsive">
				                <table class="table table_info">
				                     <tbody>
				                     	<tr>
				                     		<td colspan="2">Debit</td>
				                     	</tr>
				                        <tr>
				                            <td>{{ total_debit_pc }}</td>
				                            <td v-if="filter.rangeDate"><strong>{{ total_debit_filter_pc }}</strong></td>
				                        </tr>
				                        <tr>
				                     		 <td colspan="2">Credit</td>
				                     	</tr>
				                        <tr>
				                            <td>{{ total_credit_pc }}</td>
				                            <td v-if="filter.rangeDate"><strong>{{ total_credit_filter_pc }}</strong></td>
				                        </tr>
				                        <tr class="font_green">
				                     		 <td colspan="2">Saldo</td>
				                     	</tr>
				                        <tr class="font_green">
				                            <td>{{ total_saldo_pc }}</td>
				                            <td v-if="filter.rangeDate"><strong>{{ total_saldo_filter_pc }}</strong></td>
				                        </tr>
				                    </tbody>
				                </table>
			            	</div>
			            </div>
			        </div>
			        <div class="col-md-3">
			            <div class="panel_box">
			                <h3 class="font_blue">Small Cash</h3>
			                <table class="table table_info table-responsive">
			                     <tbody>
			                     	<tr>
			                     		<td colspan="2">Debit</td>
			                     	</tr>
			                        <tr>
			                            <td>{{ total_debit_sc }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_debit_filter_sc }}</strong></td>
			                        </tr>
			                        <tr>
			                     		<td colspan="2">Credit</td>
			                     	</tr>
			                        <tr>
			                            <td>{{ total_credit_sc }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_credit_filter_sc }}</strong></td>
			                        </tr>
			                        <tr class="font_blue">
			                     		<td colspan="2">Saldo</td>
			                     	</tr>
			                        <tr class="font_blue">
			                            <td>{{ total_saldo_sc }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_saldo_filter_sc }}</strong></td>
			                        </tr>
			                    </tbody>
			                </table>
			            </div>
			        </div>
			        <div class="col-md-3">
			            <div class="panel_box">
			                <h3 class="font_yellow">Total</h3>
			                <table class="table table_info table-responsive">
			                     <tbody>
			                     	<tr>
			                     		<td colspan="2">Debit</td>
			                     	</tr>
			                        <tr>
			                            <td>{{ total_debit }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_debit_filter }}</strong></td>
			                        </tr>
			                        <tr>
			                     		<td colspan="2">Credit</td>
			                     	</tr>
			                        <tr>
			                            <td>{{ total_credit }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_credit_filter }}</strong></td>
			                        </tr>
			                        <tr class="font_yellow">
			                     		<td colspan="2">Saldo</td>
			                     	</tr>
			                        <tr class="font_yellow">
			                            <td>{{ total_saldo }}</td>
			                            <td v-if="filter.rangeDate"><strong>{{ total_saldo_filter }}</strong></td>
			                        </tr>
			                    </tbody>
			                </table>
			            </div>
			        </div>
			    </div>
			</div>
			<div class="table-responsive ajax-table">
				<table class="table table-hover table-bordered">
					<thead>
						<tr>
							<th>#</th>
							<th>{{ fields.tb_trx_date }}</th>
							<th>{{ fields.tb_category }}</th>
							<th>{{ fields.tb_type }}</th>
							<th>{{ fields.tb_note }}</th>
							<th>{{ fields.tb_debit }}</th>
							<th>{{ fields.tb_credit }}</th>
							<th>{{ fields.tb_saldo }}</th>
							<th>Initial</th>
							<th width="120px">Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(v,k) in data.data" :key="k">
							<td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
							<td>{{v.trx_date}}</td>
							<td>{{v.category}}</td>
							<td>
								<span class="label label-sm no_radius" :style="'background:#'+v.color_cash_type">{{ v.cash_type }}</span> &nbsp;
								<StatusLabel type="type-budget" :cat="v.tb_type"></StatusLabel>
							</td>
							<td>{{v.tb_note}}</td>
							<td>{{v.debit}}</td>
							<td>{{v.credit}}</td>
							<td>{{v.saldo}}</td>
							<td>
								<span class="label label-sm no_radius" :style="'background:#'+v.color_input_by">{{ v.input_by }}</span>
								<span class="label label-sm no_radius" :style="'background:#'+v.color_update_by" v-if="v.tb_update_by">{{ v.update_by }}</span>
							</td>
							<td class="btn-action text-center">

								<a href="javascript:;" class="icon_action" @click="openDetail(v)" v-tooltip="'View Detail'"><i class="fa fa-eye"></i></a>
								<router-link v-if="open_edit" class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>
							</td>
						</tr>
						<tr v-if="NotFound">
							<td colspan="99">
								<h3 class="tc">{{NotFound}}</h3>
							</td>
						</tr>
						<tr v-if="data.data===false">
							<td colspan="99">
								<LoadingSpinner light></LoadingSpinner>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="panel-body">
				<div class="pull-right">
					<Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
				</div>
			</div>
		</div>

		<!-- ======================================================================== 
			FORM CRUD	
		============================================================================= -->
		<div class="panel panel-flat" v-if="$route.params.id">
			<VForm @resp="submitForm" method="post">
				<div class="panel-heading">
					<h2 class="panel-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h2>
				</div>
				<div class="panel-body">
					
					<div class="info"></div>
					<div class="row">
						<div class="col-sm-6">
							<BoField name="tb_cash_type">
								<input v-if="row.id" type="text" v-model="row.cash_type" class="form-control" readonly="">
								<select2 v-if="!row.id" name="tb_cash_type" v-bind="validation('tb_cash_type')" :options="BudgetCashType" :object="['mbct_id','mbct_sortname']" v-model="row.tb_cash_type" class="form-control">
									<option value="">-- Select Cash Type --</option>
								</select2>
							</BoField>
							<BoField name="tb_category">
								<select2 name="tb_category" v-bind="validation('tb_category')" :options="BudgetCategory" :object="['mbc_id','mbc_category']" v-model="row.tb_category" class="form-control" @change="addNewCategory($event)">
									<option value="">-- Select Category --</option>
									<option v-if="open_add_cat" value="-1">*Add</option>
								</select2>
							</BoField>
							<BoField name="tb_note">
								<textarea name="tb_note" rows="4" class="form-control" v-model="row.tb_note" v-bind="validation('tb_note')"></textarea>
							</BoField>
							<BoField name="tb_code" v-model="row.tb_code"></BoField>
						</div>
						<div class="col-sm-6">
							<BoField name="tb_type">
								<input v-if="row.id" type="text" v-model="row.budget_type" class="form-control" readonly="">
								<select2 v-if="!row.id" name="tb_type" v-bind="validation('tb_type')" :options="BudgetType" :object="['bgt_id','bgt_type']" v-model="row.tb_type" class="form-control">
									<option value="">-- Select Type --</option>
								</select2>
							</BoField>
							<BoField name="tb_trx_date">
								<div class="input-group">
			                      	<DatePicker name="tb_trx_date" v-model="row.tb_trx_date" v-bind="validation('tb_trx_date')"></DatePicker>
			                      	<div class="input-group-addon"><span class="ti-calendar"></span></div>
			                    </div>
							</BoField>
							<BoField name="tb_debit" v-if="row.tb_type==1">
								<div class="input-group">
									<div class="input-group-addon">Rp.</div>
									<PriceFormat name="tb_debit" class="form-control" v-model="row.tb_debit" v-bind="validation('tb_debit')"></PriceFormat>
								</div>
							</BoField>
							<BoField name="tb_credit" v-if="row.tb_type==2">
								<div class="input-group">
									<div class="input-group-addon">Rp.</div>
									<PriceFormat name="tb_credit" class="form-control" v-model="row.tb_credit" v-bind="validation('tb_credit')"></PriceFormat>
								</div>
							</BoField>
							<BoField name="tb_credit" label="Debit - Credit" v-if="row.tb_type==3">
								<div class="input-group">
									<div class="input-group-addon">Rp.</div>
									<PriceFormat name="tb_credit" class="form-control" v-model="row.tb_credit" v-bind="validation('tb_credit')"></PriceFormat>
								</div>
							</BoField>
							<BoField name="tb_photo">
								<Uploader name="tb_photo" type="budgeting" uploadType="gallery" v-model="row.tb_photo" v-bind="validation('tb_photo')" :galleryParams="{multiple:true}"></Uploader>
							</BoField>
						</div>
						<div class="col-xs-12">
							<div class="text-right">
								<button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
							</div>
						</div>
					</div>
				</div>
			</VForm>
		</div>

		<!-- MODAL -->
		<VModal name="addNewCategory" title="Add Category" method="post" noFooter @resp="submitCategory">
			<div class="infoModal"></div>
			<div class="row">
				<div class="col-sm-6">
					<BoField name="mbc_category" v-model="row2.mbc_category" mandatory :attr="{required:true}"></BoField>
				</div>
				<div class="col-sm-6">
					<BoField name="mbc_is_active">
						<div class="radio-group">
							<radio name="mbc_is_active" v-model="row2.mbc_is_active" option="Y" :attr="validation('mbc_is_active')">Active</radio>
							<radio name="mbc_is_active" v-model="row2.mbc_is_active" option="N">Inactive</radio>
						</div>
					</BoField>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal"">Close</button>
				<button type="submit" class="btn btn-primary btn-loading">Submit</button>
			</div>
		</VModal>

		<VModal name="detailBudget" title="Detail Budget" method="post" noFooter>
			
			<table class="table">
				<tbody>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Trx Date</h4>
								<p>{{ detail.trx_date }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Trx Type</h4>
								<p>{{ detail.budget_type }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Cash Type</h4>
								<p>{{ detail.cash_type }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Inputter</h4>
								<p>Input: {{ detail.input }}</p>
								<p v-if="detail.update">Update: {{ detail.update }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Note</h4>
								<p>{{ detail.note }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Amount</h4>
								<p>{{ detail.debit_credit }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>
							<div class="detail_report">
								<h4>Code</h4>
								<p>{{ detail.code }}</p>
							</div>
						</td>
						<td>
							<div class="detail_report">
								<h4>Trx Proof</h4><br>
								<p v-if="!detail.photo">-</p>
		                        <p v-if="detail.photo">
		                        	<img v-for="(v,k) in detail.photo" class="fancybox" :src="uploader(v)" width="70px">
		                        </p>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</VModal>
	</div>
</template>
